export const MeLFilterMethod = (filter, row) => {
  const rowValue = row[filter.id];
  if (!filter.value || filter.value.length === 0) {
    return true;
  }
  return rowValue === filter.value;
};
